import React from 'react';
import PropTypes from 'prop-types';

import ArtifactHealthIcon from './ArtifactHealthIcon';

const ArtifactHealthItem = ({
  children,
  symbol,
  color
}) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <div style={{ paddingRight: '5px', lineHeight: 0 }}>
      <ArtifactHealthIcon symbol={symbol} color={color} />
    </div>
    {children}
  </div>
);

ArtifactHealthItem.propTypes = {
  children: PropTypes.any,
  symbol: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired
};

export default ArtifactHealthItem;


// WEBPACK FOOTER //
// src/Components/ArtifactHealthItem.jsx